import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { UIResponsiveImageWrapper } from '@irohalab/deneb-ui';
import { ImageInfo, ItemRelation, ItemSubType, ItemType, MainItemBasic } from '@irohalab/mira-sdk-angular';
import { DEFAULT_IMAGE_INFO, formatPublicTime } from '../utils';

interface ItemWithRelation {
  name?: string;
  nameCn?: string;
  type?: ItemType;
  subType?: ItemSubType;
  itemId: string | null | undefined;
  relationType: string | undefined;
  coverImage: ImageInfo;
  imageRatio: number;
  publicTime: string;
}

@Component({
    selector: 'app-item-list',
    imports: [
    UIResponsiveImageWrapper
],
    templateUrl: './item-list.component.html',
    styleUrl: './item-list.component.less'
})
export class ItemListComponent implements OnChanges {
  @Input()
  relatedMainItems!: MainItemBasic[];

  @Input()
  relations!: ItemRelation[];

  relationTypeList: string[] = [];

  itemsWithRelationMap: {[key: string]: ItemWithRelation[]} = {};

  ngOnChanges(changes: SimpleChanges): void {
    this.initializeItemsWithRelationMap();
  }

  private initializeItemsWithRelationMap(): void {
    if (this.relations?.length > 0 && this.relatedMainItems?.length > 0) {
      for (const relation of this.relations) {
        if (!this.itemsWithRelationMap[relation.relationType]) {
          this.itemsWithRelationMap[relation.relationType] = [];
        }
        const mainItem = this.relatedMainItems.find(item => item.id === relation.relatedItemId);
        if (mainItem) {
          let image = mainItem.coverImage;
          if (!image) {
            image = DEFAULT_IMAGE_INFO;
          }
          const itemWithRelation = {
            name: mainItem.name,
            nameCn: mainItem.nameCn,
            type: mainItem.type,
            subType: mainItem.subType,
            itemId: mainItem.id,
            relationType: relation.relationType,
            coverImage: image,
            imageRatio: image.height / image.width,
            publicTime: formatPublicTime(mainItem.publicTime),
          };
          this.itemsWithRelationMap[relation.relationType].push(itemWithRelation);
        }
      }

      this.relationTypeList = Object.keys(this.itemsWithRelationMap);
    }
  }
}
